import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const linkEntity: Entity = {
  model: model,
  repository: repository,
}

export default linkEntity
